import { IRegEdSubmissionMetadata } from '@Queries/RegEdCompliance';
import * as Api from '@ViewModels';
import { Button } from '@HoudiniUI/Button';
import { css } from 'aphrodite';
import * as React from 'react';
import { CampaignType } from '../../../../../../models/AdminModels';
import { RegEdComplianceApprovalPrompt } from '../../../../../components/campaigns/ComplianceApprovalPrompt/RegEdComplianceApprovalPrompt';
import { bs } from '../../../../../styles/styles';
import { MobileImageUploadButtons } from './MobileImageUploadButtons';
import { mobileStyles } from '../styles';

const MAX_MOBILE_IMAGES = 5;

interface MobileActionButtonsProps {
	onScheduleForLater: () => void;
	onPostNow: () => void;
	onUploadMedia?: () => void;
	onFreeImages?: () => void;
	canPostNow: boolean;
	canSchedule: boolean;
	isSchedulingInProgress: boolean;
	showPostNow: boolean;
	imageCount?: number;
	usesRegEd?: boolean;
	onScheduleRegEdCompliance?: (e: React.MouseEvent<HTMLElement>, metadata: IRegEdSubmissionMetadata) => void;
	onScheduleWithoutCompliance?: (e: React.MouseEvent<HTMLElement>) => void;
	regEdMetadata?: IRegEdSubmissionMetadata | null;
	socialProviders?: readonly Api.SocialMediaType[];
	impersonationCtx?: Api.IImpersonationContext;
}

const MobileActionButtons: React.FC<MobileActionButtonsProps> = ({
	onScheduleForLater,
	onPostNow,
	onUploadMedia,
	onFreeImages,
	canPostNow,
	canSchedule,
	isSchedulingInProgress,
	showPostNow,
	imageCount = 0,
	usesRegEd,
	onScheduleRegEdCompliance,
	onScheduleWithoutCompliance,
	regEdMetadata,
	socialProviders,
	impersonationCtx,
}) => {
	const shouldShowImageButtons =
		!!(onUploadMedia || onFreeImages) && imageCount < MAX_MOBILE_IMAGES && !isSchedulingInProgress;

	return (
		<div
			className={css(mobileStyles.actionButtonsContainer, usesRegEd && mobileStyles.actionButtonsContainerRegEd)}
			data-reged-host={usesRegEd ? '' : undefined}
		>
			{shouldShowImageButtons && (
				<MobileImageUploadButtons
					onClickFreeImage={onFreeImages}
					onClickMedia={onUploadMedia}
					currentImageCount={imageCount}
					maxImages={MAX_MOBILE_IMAGES}
				/>
			)}

			<div className={css(mobileStyles.actionButtons, usesRegEd && mobileStyles.actionButtonsRegEd)}>
				{usesRegEd && onScheduleRegEdCompliance ? (
					<RegEdComplianceApprovalPrompt
						impersonationContext={impersonationCtx}
						campaignType={CampaignType.Social}
						socialProviders={socialProviders}
						collapsible
						disabled={!canSchedule}
						isLoading={isSchedulingInProgress}
						initialFormat={regEdMetadata?.format}
						initialAnswers={regEdMetadata?.answers}
						onScheduleRegEdCompliance={onScheduleRegEdCompliance}
						onScheduleWithoutCompliance={onScheduleWithoutCompliance}
						styles={[mobileStyles.regEdPromptInSidebar]}
					/>
				) : (
					<Button
						styles={[mobileStyles.scheduleButton]}
						onClick={onScheduleForLater}
						disabled={!canSchedule || isSchedulingInProgress}
					>
						{isSchedulingInProgress ? 'Scheduling...' : 'Schedule for Later'}
					</Button>
				)}

				{showPostNow && (
					<button
						className={css(bs.ctaButtonReverse)}
						onClick={onPostNow}
						disabled={!canPostNow || isSchedulingInProgress}
					>
						Post Now
					</button>
				)}
			</div>
		</div>
	);
};

export { MobileActionButtons };
